// CineFrame Theme JS

// Cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.cart-count');
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
}

// Add to cart AJAX
document.querySelectorAll('.btn-cart').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓ Added!';
      btn.style.background = '#4caf50';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = orig;
        btn.style.background = '';
        btn.disabled = false;
      }, 1600);
    })
    .catch(() => {
      btn.textContent = 'Error';
      btn.disabled = false;
    });
  });
});

// Wishlist toggle (visual only - connect to app for real wishlists)
document.querySelectorAll('.btn-wish').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isWished = btn.textContent.trim() === '♥';
    btn.textContent = isWished ? '♡' : '♥';
    btn.style.color = isWished ? '' : '#e74c3c';
  });
});

// Variant selection on product page
document.querySelectorAll('.variant-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.variant-options');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const addBtn = document.querySelector('.add-to-cart-btn');
    if (addBtn && btn.dataset.variantId) {
      addBtn.dataset.variantId = btn.dataset.variantId;
    }
  });
});

// Add to cart from product page
const addToCartBtn = document.querySelector('.add-to-cart-btn');
if (addToCartBtn) {
  addToCartBtn.addEventListener('click', () => {
    const variantId = addToCartBtn.dataset.variantId;
    if (!variantId) return;
    const orig = addToCartBtn.textContent;
    addToCartBtn.textContent = 'Adding…';
    addToCartBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      addToCartBtn.textContent = '✓ Added to Cart!';
      addToCartBtn.style.background = '#4caf50';
      updateCartCount();
      setTimeout(() => {
        addToCartBtn.textContent = orig;
        addToCartBtn.style.background = '';
        addToCartBtn.disabled = false;
      }, 2000);
    });
  });
}

updateCartCount();
